import React from 'react';
import {
  Text,
  View,
} from 'react-native';
import { getMediumFont } from '../../../../utils/Utils';
//= ========================================================================

const TextLink_9_3 = ({
  children, globJSON, simPlatform, withOutAlign, marginTop,
}) => (
  <View>
    <Text
      style={{
        marginTop,
        paddingVertical: !withOutAlign && 10,
        textAlign: !withOutAlign && 'center',
        fontFamily: `${getMediumFont(globJSON, simPlatform)}`,
        fontSize: 9.3,
        color: globJSON.configurations.theme.colors.links_icons_color,
      }}
    >
      {children}
    </Text>
  </View>
);
export default TextLink_9_3;
